import script from "./ExecutiveDashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExecutiveDashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./ExecutiveDashboardPage.vue?vue&type=style&index=0&id=5af9280d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af9280d"]])

export default __exports__